import { handleActions } from 'redux-actions'
import { fromJS, Set } from 'immutable'

import * as Actions from 'actions/saved_searches'
import * as AppActions from 'actions/app'

const savedSearchIdFrom = payload => (payload && typeof payload === 'object' ? payload.savedSearchId : payload)

export const initialState = fromJS({
  show: false,
  selectedGroupId: 0
}).set('savingSavedSearchIds', Set())

export default handleActions({
  [Actions.showAssignSavedSearchesToGroupDialog]: (state, { payload: groupId }) => state.merge({
    show: true,
    selectedGroupId: groupId
  }),
  [Actions.hideAssignSavedSearchesToGroupDialog]: state => state.set('show', false),

  [Actions.assignSavedSearchToGroupStart]: (state, { payload }) => (
    state.update('savingSavedSearchIds', ids => ids.add(savedSearchIdFrom(payload)))
  ),
  [Actions.assignSavedSearchToGroupSuccess]: (state, { payload }) => (
    state.update('savingSavedSearchIds', ids => ids.remove(savedSearchIdFrom(payload)))
  ),
  [Actions.assignSavedSearchToGroupError]: (state, { payload }) => (
    state.update('savingSavedSearchIds', ids => ids.remove(savedSearchIdFrom(payload)))
  ),

  [Actions.removeSavedSearchFromGroupStart]: (state, { payload }) => (
    state.update('savingSavedSearchIds', ids => ids.add(savedSearchIdFrom(payload)))
  ),
  [Actions.removeSavedSearchFromGroupSuccess]: (state, { payload }) => (
    state.update('savingSavedSearchIds', ids => ids.remove(savedSearchIdFrom(payload)))
  ),
  [Actions.removeSavedSearchFromGroupError]: (state, { payload }) => (
    state.update('savingSavedSearchIds', ids => ids.remove(savedSearchIdFrom(payload)))
  ),

  [AppActions.resetState]: () => initialState
}, initialState)
